import { navWidth } from "components/LeftMenu/LeftMenu.styles";
import PanelBackButton from "containers/RightPanel/components/PanelBackButton";
import IconButton from "components/IconButton";
import { TooltipTrigger } from "components/Tooltip/Tooltip";
import { PANEL_WIDTH } from "containers/RightPanel/RightPanel.styles";
import { Container } from "react-grid-system";
import styled from "styled-components";
import { pageTitle } from "styles/typography";
import Icon from "../../../components/Icon/Icon";
import Input from "../../../components/Input/Input";
import { PageWrapper } from "../../../layouts/Layout.styles";
import {
  fadeInLeft,
  fadeOutRight,
  ListHeader,
  ListHeaderTitle,
  ParcelCol,
  ParcelRow,
} from "../../../styles/parcelsStyles";

export const WeightWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2px;
  white-space: nowrap;
  width: 100%;
  text-align: left;
`;

export const ConsolidationNumber = styled("div")`
  color: ${(props) => props.theme.black50};
`;

export const QuantityWrapper = styled("div")`
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-right: 20px;
`;

export const QuantityEdit = styled("div")`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ButtonsWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
`;

export const StyledInput = styled(Input)`
  width: 30px;

  & input {
    height: 30px;
    padding: 10px 5px;
  }
`;

export const UpArrowIcon = styled(Icon)`
  transform: rotate(90deg);
`;

export const DownArrowIcon = styled(Icon)`
  transform: rotate(-90deg);
`;

// Quantity up and down on an inventory row or tile.
export const StepperButton = styled(IconButton).attrs({ compact: true })``;

interface ParcelRowProps {
  selected: boolean;
  disabled?: boolean;
}

export const InventoryItemRowContainer = styled(ParcelRow)<ParcelRowProps>`
  ${({ theme }) => theme.range("padding", "0px", "6px")};

  ${({ theme, selected }) => `
    background-color: ${selected ? theme.selectedRowBg : "transparent"};
  `};

  ${({ disabled }) =>
    disabled &&
    `opacity: 0.5;
      pointer-events: none;
     `}
`;

export const CheckboxAreaButton = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  padding: 15px 10px 15px 15px;
  flex-shrink: 0;
`;

export const Description = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  line-height: 17px;
  overflow: hidden;
  text-overflow: ellipsis;

  /* The description text sits in a button inside the tooltip trigger; cap
     both so a long description ellipsizes instead of wrapping. */
  ${TooltipTrigger} {
    max-width: 100%;
  }

  button {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  }

  img {
    margin: 0 0 0 10px;

    &:first-child {
      margin-left: 15px;
    }
  }

  ${(props) => props.theme.sm`
    margin-left: 12px;
  `}

  ${(props) => props.theme.md`
    margin-left: 0;

    img {
      width: 12px;
      height: 12px;
      margin-left: 6px;
    }
  `}

  &[disabled] {
    color: ${(props) => props.theme.black50};
  }
`;

export const ParcelDate = styled.div`
  text-align: left;
  white-space: nowrap;
  width: 100%;

  ${(props) => props.theme.md`
    margin-top: 20px;
    padding-left: 20px;
    margin-bottom: 15px;
`}
`;

export const ImageSection = styled.div`
  display: flex;
  height: 85px;
  margin: 5px 15px 5px 10px;
  min-width: 58px;
  width: 58px;
  flex-shrink: 0;
`;

export const Comment = styled.span`
  font-size: 12px;
  text-align: left;
  width: 100%;
  color: ${(props) => props.theme.black50};
`;

export const LocationWrapper = styled("div")`
  width: 50%;
  text-align: center;
`;

interface WrapperInventoryProps {
  $isPanelOpened?: boolean;
}

export const WrapperInventory = styled(PageWrapper)<WrapperInventoryProps>`
  position: absolute;
  width: ${({ $isPanelOpened }) =>
    $isPanelOpened ? `calc(100% - ${PANEL_WIDTH})` : "100%"};
  transition: width 0.2s ease-out;
  animation: none;

  ${(props) => props.theme.xs`
    width: 100%;
  `}

  &.page-enter {
    animation: ${fadeInLeft} 0.22s ease;
  }

  &.page-exit {
    animation: ${fadeOutRight} 0.22s ease;
  }
`;

export const StyledGrid = styled(Container)`
  position: relative;
`;

export const StyledListHeader = styled(ListHeader)`
  align-items: center;
`;

export const StyledListHeaderTitle = styled(ListHeaderTitle)`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

export const StorageHeading = styled.div`
  display: flex;
  flex-direction: column-reverse;
`;

export const SelectAllSwitchWrapper = styled.div`
  margin-right: 8px;
  transform: translateY(4px);
`;

export const ButtonsWrapperInventory = styled.div`
  width: 100%;
  height: 80px;
`;

export const Buttons = styled.div`
  padding: 10px 30px 20px 30px;
  background-color: ${({ theme }) => theme.surface};
  position: fixed;
  display: flex;
  left: ${navWidth};
  bottom: 0;
  width: 100%;

  & > div {
    display: flex;
    margin: 0 10px;
  }

  & > button {
    margin: 0 10px;
    min-width: 150px;
  }

  &::before {
    content: "";
    position: fixed;
    box-shadow: 0 1px 38px 22px ${({ theme }) => theme.fadeMask};
    background-color: ${({ theme }) => theme.fadeMask};
    height: 72px;
    width: 100%;
    bottom: 0;
    left: 110px;
    z-index: -1;
  }

  ${(props) => props.theme.sm`
    left: 0;

    &::before {
      left: 0;
    }
  `}

  ${(props) => props.theme.xs`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    button {
      margin: 5px;
    }
  `}
`;

export const BackButtonInventory = styled(PanelBackButton)`
  margin-right: 20px;

  ${(props) => props.theme.xs`
     margin-right: 8px;
`};
`;

export const Message = styled.p`
  margin: 17px 0;
  font-size: 26px;
  ${pageTitle}
  color: ${(props) => props.theme.black};
`;

export const InventoryListWrapper = styled.div`
  width: 100%;
  padding-bottom: 20px;
`;

export const GroupName = styled.button`
  display: block;
  width: 100%;
  padding: 20px 0 0;
  border: none;
  background: none;
  text-align: left;
  font-family: inherit;
  font-size: 20px;
  ${pageTitle}
  color: inherit;
  cursor: pointer;
  user-select: none;
`;
